// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'

import { castToFloat } from 'helpers/reduxFormFunctions'
import getEngineeringReferenceThroughput from './getEngineeringReferenceThroughput'

// when enabling a modulation, need to determine if the engineering reference should update
// if the radio's model number should update
// and if the radio's max/coordinated powers should update.

const enableModulation = (radioName, radioConfig, modConfig) => (dispatch, getState) => {
  const sourceForm = getState().pathDetails.get('sourceForm')

  const changeField = (fieldName, value) => (
    dispatch(change(sourceForm, `${radioName}${fieldName}`, value))
  )

  const {
    radioModulationId,
    txPowerMax,
  } = modConfig

  // - check to see if maxPower is below the new power, if so , set it to the new value.
  // - - must keep coordinated power in sync here as well
  if (
    !radioConfig.maxPower ||
    castToFloat(radioConfig.maxPower) < castToFloat(txPowerMax)
  ) {
    changeField('maxPower', txPowerMax)
    changeField('coordinatedPower', txPowerMax)
  }

  // - check to see if this row has greater throughput than the engineering reference,
  // - - if so, set this dude to be the engineering reference.
  // - - also change the radio model to be the new engineeringReference's model name
  const currentEngRefThroughput = getEngineeringReferenceThroughput(radioConfig)
  if (currentEngRefThroughput < modConfig.throughput) {
    changeField('engineeringReference', radioModulationId)
    changeField('modelNumber', modConfig.modelNumber)
  }

  if (modConfig.bandwidth > radioConfig.bandwidth) {
    changeField('bandwidth', modConfig.bandwidth)
  }
}

export default enableModulation
